// DS1.5
import React from 'react';
const Logo = ({ className, style, markColor = 'green', markColorClassname, textColor = 'black', textColorClassname, size = 'medium', withText = true })=>{
    return /*#__PURE__*/ React.createElement("div", {
        style: style
    }, !withText && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: 33,
        height: 30,
        viewBox: "0 0 33 30",
        fill: "none",
        preserveAspectRatio: "xMidYMid meet"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m8.031 14.887 4.315.032.17.22-4.736 8.966a.25.25 0 0 0-.029.116v4.652c0 .138.112.25.25.25h4.777a.25.25 0 0 0 .178-.074l.25-.254a2 2 0 0 0 .208-.276q.12-.183.288-.473c.225-.389.522-.932.897-1.64.537-1.013.81-1.524.99-1.812.087-.142.147-.22.197-.272a1 1 0 0 1 .175-.143l.274-.192h7.968a.25.25 0 0 0 .25-.25v-6.469a.25.25 0 0 0-.25-.25h-4.267l-.101-.125a2 2 0 0 1-.097-.135l.136-.27c.12-.235.293-.572.508-.985.43-.825 1.021-1.954 1.673-3.187l2.37-4.484a.25.25 0 0 0 .028-.117V3a.25.25 0 0 0-.25-.25h-4.778a.25.25 0 0 0-.178.075l-.217.221a2 2 0 0 0-.204.289c-.082.132-.186.308-.306.517-.24.418-.546.975-.878 1.602l-1.1 2.073-.643.423H8a.25.25 0 0 0-.25.251l.033 6.437a.25.25 0 0 0 .248.249Z",
        fill: "url(#a)",
        stroke: "url(#b)",
        strokeWidth: 0.5,
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.388 2.396a4 4 0 0 0-.137.203c-.078.125-.179.295-.297.501-.236.412-.54.965-.87 1.588l-.221-.117.22.117-1.13 2.13a.25.25 0 0 1-.083.091l-.759.5a.25.25 0 0 1-.137.04l-7.723.001.03 5.939 4.19.031a.25.25 0 0 1 .197.097l.341.443a.25.25 0 0 1 .023.27l-4.78 9.053v4.34h4.422l.176-.179c.023-.023.07-.084.146-.2q.109-.164.274-.45c.22-.38.513-.916.888-1.622l.22.117-.22-.117c.532-1.004.815-1.535 1.006-1.842a2 2 0 0 1 .26-.352c.084-.09.165-.149.25-.208l.338-.238a.25.25 0 0 1 .144-.045h7.797v-5.969h-4.137a.25.25 0 0 1-.194-.093l-.176-.218.194-.157c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558zm0 0 .142-.146h4.423v4.403z",
        fill: "url(#c)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.388 2.396a4 4 0 0 0-.137.203c-.078.125-.179.295-.297.501-.236.412-.54.965-.87 1.588l-.221-.117.22.117-1.13 2.13a.25.25 0 0 1-.083.091l-.759.5a.25.25 0 0 1-.137.04l-7.723.001.03 5.939 4.19.031a.25.25 0 0 1 .197.097l.341.443a.25.25 0 0 1 .023.27l-4.78 9.053v4.34h4.422l.176-.179c.023-.023.07-.084.146-.2q.109-.164.274-.45c.22-.38.513-.916.888-1.622l.22.117-.22-.117c.532-1.004.815-1.535 1.006-1.842a2 2 0 0 1 .26-.352c.084-.09.165-.149.25-.208l.338-.238a.25.25 0 0 1 .144-.045h7.797v-5.969h-4.137a.25.25 0 0 1-.194-.093l-.176-.218.194-.157c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558zm0 0 .142-.146h4.423v4.403z",
        stroke: "url(#d)",
        strokeWidth: 0.5,
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.388 2.396a4 4 0 0 0-.137.203c-.078.125-.179.295-.297.501-.236.412-.54.965-.87 1.588l-.221-.117.22.117-1.13 2.13a.25.25 0 0 1-.083.091l-.759.5a.25.25 0 0 1-.137.04l-7.723.001.03 5.939 4.19.031a.25.25 0 0 1 .197.097l.341.443a.25.25 0 0 1 .023.27l-4.78 9.053v4.34h4.422l.176-.179c.023-.023.07-.084.146-.2q.109-.164.274-.45c.22-.38.513-.916.888-1.622l.22.117-.22-.117c.532-1.004.815-1.535 1.006-1.842a2 2 0 0 1 .26-.352c.084-.09.165-.149.25-.208l.338-.238a.25.25 0 0 1 .144-.045h7.797v-5.969h-4.137a.25.25 0 0 1-.194-.093l-.176-.218.194-.157c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558zm0 0 .142-.146h4.423v4.403z",
        stroke: "url(#e)",
        strokeWidth: 0.5,
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.388 2.396a4 4 0 0 0-.137.203c-.078.125-.179.295-.297.501-.236.412-.54.965-.87 1.588l-.221-.117.22.117-1.13 2.13a.25.25 0 0 1-.083.091l-.759.5a.25.25 0 0 1-.137.04l-7.723.001.03 5.939 4.19.031a.25.25 0 0 1 .197.097l.341.443a.25.25 0 0 1 .023.27l-4.78 9.053v4.34h4.422l.176-.179c.023-.023.07-.084.146-.2q.109-.164.274-.45c.22-.38.513-.916.888-1.622l.22.117-.22-.117c.532-1.004.815-1.535 1.006-1.842a2 2 0 0 1 .26-.352c.084-.09.165-.149.25-.208l.338-.238a.25.25 0 0 1 .144-.045h7.797v-5.969h-4.137a.25.25 0 0 1-.194-.093l-.176-.218.194-.157c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558zm0 0 .142-.146h4.423v4.403z",
        fill: "url(#f)",
        stroke: "url(#g)",
        strokeWidth: 0.5,
        strokeLinejoin: "round",
        style: {
            mixBlendMode: 'screen'
        },
        opacity: 0.4
    }), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'overlay'
        }
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19.388 2.396a4 4 0 0 0-.137.203c-.078.125-.179.295-.297.501-.236.412-.54.965-.87 1.588l-.221-.117.22.117-1.13 2.13a.25.25 0 0 1-.083.091l-.759.5a.25.25 0 0 1-.137.04l-7.723.001.03 5.939 4.19.031a.25.25 0 0 1 .197.097l.341.443a.25.25 0 0 1 .023.27l-4.78 9.053v4.34h4.422l.176-.179c.023-.023.07-.084.146-.2q.109-.164.274-.45c.22-.38.513-.916.888-1.622l.22.117-.22-.117c.532-1.004.815-1.535 1.006-1.842a2 2 0 0 1 .26-.352c.084-.09.165-.149.25-.208l.338-.238a.25.25 0 0 1 .144-.045h7.797v-5.969h-4.137a.25.25 0 0 1-.194-.093l-.176-.218.194-.157c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558zm0 0 .142-.146h4.423v4.403z",
        fill: "url(#h)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.388 2.396a4 4 0 0 0-.137.203c-.078.125-.179.295-.297.501-.236.412-.54.965-.87 1.588l-.221-.117.22.117-1.13 2.13a.25.25 0 0 1-.083.091l-.759.5a.25.25 0 0 1-.137.04l-7.723.001.03 5.939 4.19.031a.25.25 0 0 1 .197.097l.341.443a.25.25 0 0 1 .023.27l-4.78 9.053v4.34h4.422l.176-.179c.023-.023.07-.084.146-.2q.109-.164.274-.45c.22-.38.513-.916.888-1.622l.22.117-.22-.117c.532-1.004.815-1.535 1.006-1.842a2 2 0 0 1 .26-.352c.084-.09.165-.149.25-.208l.338-.238a.25.25 0 0 1 .144-.045h7.797v-5.969h-4.137a.25.25 0 0 1-.194-.093l-.176-.218.194-.157c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558zm0 0 .142-.146h4.423v4.403z",
        stroke: "url(#i)",
        strokeWidth: 0.5,
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.388 2.396a4 4 0 0 0-.137.203c-.078.125-.179.295-.297.501-.236.412-.54.965-.87 1.588l-.221-.117.22.117-1.13 2.13a.25.25 0 0 1-.083.091l-.759.5a.25.25 0 0 1-.137.04l-7.723.001.03 5.939 4.19.031a.25.25 0 0 1 .197.097l.341.443a.25.25 0 0 1 .023.27l-4.78 9.053v4.34h4.422l.176-.179c.023-.023.07-.084.146-.2q.109-.164.274-.45c.22-.38.513-.916.888-1.622l.22.117-.22-.117c.532-1.004.815-1.535 1.006-1.842a2 2 0 0 1 .26-.352c.084-.09.165-.149.25-.208l.338-.238a.25.25 0 0 1 .144-.045h7.797v-5.969h-4.137a.25.25 0 0 1-.194-.093l-.176-.218.194-.157c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558zm0 0 .142-.146h4.423v4.403z",
        stroke: "url(#j)",
        strokeWidth: 0.5,
        strokeLinejoin: "round"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "a",
        x1: 50,
        y1: 28,
        x2: 50,
        y2: 10,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#875C16"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D08618"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "b",
        x1: 52.5,
        y1: 3,
        x2: 52.5,
        y2: 29,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "c",
        x1: 88,
        y1: 28,
        x2: 25.5,
        y2: -3.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCE83"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.421,
        stopColor: "#AF884E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.59,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.664,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#94641E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "d",
        x1: 59.904,
        y1: 2,
        x2: 59.904,
        y2: 28,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.129,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.354,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.708,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "e",
        x1: 52.5,
        y1: 2,
        x2: 52.5,
        y2: 28,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "f",
        x1: 87,
        y1: 22.5,
        x2: 34.5,
        y2: -2.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "g",
        x1: 16.102,
        y1: 2,
        x2: 16.102,
        y2: 27.873,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "h",
        x1: 137,
        y1: 24.5,
        x2: 8,
        y2: 2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#A17739"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.662,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.74,
        stopColor: "#D3A147"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.874,
        stopColor: "#D5A349"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.895,
        stopColor: "#FFEFCF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "i",
        x1: 59.904,
        y1: 2,
        x2: 59.904,
        y2: 28,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "j",
        x1: 8,
        y1: 15,
        x2: 111.809,
        y2: 15,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D28E21"
    }))))), withText && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 132,
        height: 54,
        fill: "none"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "f",
        maskUnits: "userSpaceOnUse",
        x: 17,
        y: 14,
        width: 106,
        height: 28,
        fill: "#000"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M17 14h106v28H17z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M51.042 15.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 15zM57.77 26.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11M81.08 26.62h3.522V15.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V15.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23m-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 36.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253M29.21 15.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V15h-4.779z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 38.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V41h-9.162zM91.653 41v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V41z"
    })), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M51.042 15.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 15zM57.77 26.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11M81.08 26.62h3.522V15.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V15.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23m-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 36.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253",
        fill: "url(#a)"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.21 15.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V15h-4.779z",
        fill: "url(#b)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 38.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V41h-9.162z",
        fill: "url(#c)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 41v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V41z",
        fill: "url(#d)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M51.042 15.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 15zM57.77 26.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 26.62h3.522V15.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V15.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 36.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        stroke: "url(#e)",
        strokeLinejoin: "round",
        mask: "url(#f)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M29.21 15.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V15h-4.779z",
        stroke: "url(#g)",
        strokeLinejoin: "round",
        mask: "url(#f)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 38.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V41h-9.162z",
        stroke: "url(#h)",
        strokeLinejoin: "round",
        mask: "url(#f)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 41v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V41z",
        stroke: "url(#i)",
        strokeLinejoin: "round",
        mask: "url(#f)"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "o",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11M81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23m-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162zM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    })), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11M81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23m-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253",
        fill: "url(#j)"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        fill: "url(#k)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        fill: "url(#l)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        fill: "url(#m)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        stroke: "url(#n)",
        strokeLinejoin: "round",
        mask: "url(#o)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        stroke: "url(#p)",
        strokeLinejoin: "round",
        mask: "url(#o)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        stroke: "url(#q)",
        strokeLinejoin: "round",
        mask: "url(#o)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        stroke: "url(#r)",
        strokeLinejoin: "round",
        mask: "url(#o)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        stroke: "url(#s)",
        strokeLinejoin: "round",
        mask: "url(#o)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        stroke: "url(#t)",
        strokeLinejoin: "round",
        mask: "url(#o)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        stroke: "url(#u)",
        strokeLinejoin: "round",
        mask: "url(#o)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        stroke: "url(#v)",
        strokeLinejoin: "round",
        mask: "url(#o)"
    }), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'screen'
        },
        opacity: 0.4
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "B",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11M81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23m-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162zM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    })), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11M81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23m-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253",
        fill: "url(#w)"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        fill: "url(#x)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        fill: "url(#y)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        fill: "url(#z)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        stroke: "url(#A)",
        strokeLinejoin: "round",
        mask: "url(#B)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        stroke: "url(#C)",
        strokeLinejoin: "round",
        mask: "url(#B)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        stroke: "url(#D)",
        strokeLinejoin: "round",
        mask: "url(#B)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        stroke: "url(#E)",
        strokeLinejoin: "round",
        mask: "url(#B)"
    })), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'overlay'
        }
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "K",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11M81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23m-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162zM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    })), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11M81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23m-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253",
        fill: "url(#F)"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        fill: "url(#G)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        fill: "url(#H)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        fill: "url(#I)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        stroke: "url(#J)",
        strokeLinejoin: "round",
        mask: "url(#K)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463s-.631 1.202-.631 1.221.284.035.631.035c1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.624-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765s-1.376-5.715-1.376-5.736-.848-.037-1.885-.037h-1.884zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        stroke: "url(#L)",
        strokeLinejoin: "round",
        mask: "url(#K)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        stroke: "url(#M)",
        strokeLinejoin: "round",
        mask: "url(#K)"
    }), /*#__PURE__*/ React.createElement("path", {
        clipRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        stroke: "url(#N)",
        strokeLinejoin: "round",
        mask: "url(#K)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        stroke: "url(#O)",
        strokeLinejoin: "round",
        mask: "url(#K)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        stroke: "url(#P)",
        strokeLinejoin: "round",
        mask: "url(#K)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        stroke: "url(#Q)",
        strokeLinejoin: "round",
        mask: "url(#K)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        stroke: "url(#R)",
        strokeLinejoin: "round",
        mask: "url(#K)"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "a",
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 22,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#875C16"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D08618"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "b",
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 22,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#875C16"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D08618"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "c",
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 22,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#875C16"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D08618"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "d",
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 22,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#875C16"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D08618"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "e",
        x1: 62.5,
        y1: 15,
        x2: 62.5,
        y2: 41,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "g",
        x1: 62.5,
        y1: 15,
        x2: 62.5,
        y2: 41,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "h",
        x1: 62.5,
        y1: 15,
        x2: 62.5,
        y2: 41,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "i",
        x1: 62.5,
        y1: 15,
        x2: 62.5,
        y2: 41,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "j",
        x1: 98,
        y1: 40,
        x2: 35.5,
        y2: 8.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCE83"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.421,
        stopColor: "#AF884E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.59,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.664,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#94641E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "k",
        x1: 98,
        y1: 40,
        x2: 35.5,
        y2: 8.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCE83"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.421,
        stopColor: "#AF884E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.59,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.664,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#94641E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "l",
        x1: 98,
        y1: 40,
        x2: 35.5,
        y2: 8.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCE83"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.421,
        stopColor: "#AF884E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.59,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.664,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#94641E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "m",
        x1: 98,
        y1: 40,
        x2: 35.5,
        y2: 8.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCE83"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.421,
        stopColor: "#AF884E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.59,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.664,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#94641E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "n",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.129,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.354,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.708,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "p",
        x1: 62.5,
        y1: 14,
        x2: 62.5,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "q",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.129,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.354,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.708,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "r",
        x1: 62.5,
        y1: 14,
        x2: 62.5,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "s",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.129,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.354,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.708,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "t",
        x1: 62.5,
        y1: 14,
        x2: 62.5,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "u",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.129,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.354,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.708,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "v",
        x1: 62.5,
        y1: 14,
        x2: 62.5,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCD73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "w",
        x1: 97,
        y1: 34.5,
        x2: 44.5,
        y2: 9.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "x",
        x1: 97,
        y1: 34.5,
        x2: 44.5,
        y2: 9.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "y",
        x1: 97,
        y1: 34.5,
        x2: 44.5,
        y2: 9.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "z",
        x1: 97,
        y1: 34.5,
        x2: 44.5,
        y2: 9.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "A",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "C",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "D",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "E",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "F",
        x1: 147,
        y1: 36.5,
        x2: 18,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#A17739"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.662,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.74,
        stopColor: "#D3A147"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.874,
        stopColor: "#D5A349"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.895,
        stopColor: "#FFEFCF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "G",
        x1: 147,
        y1: 36.5,
        x2: 18,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#A17739"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.662,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.74,
        stopColor: "#D3A147"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.874,
        stopColor: "#D5A349"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.895,
        stopColor: "#FFEFCF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "H",
        x1: 147,
        y1: 36.5,
        x2: 18,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#A17739"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.662,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.74,
        stopColor: "#D3A147"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.874,
        stopColor: "#D5A349"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.895,
        stopColor: "#FFEFCF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "I",
        x1: 147,
        y1: 36.5,
        x2: 18,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#A17739"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.662,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.74,
        stopColor: "#D3A147"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.874,
        stopColor: "#D5A349"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.895,
        stopColor: "#FFEFCF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "J",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "L",
        x1: 18,
        y1: 27,
        x2: 121.809,
        y2: 27,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D28E21"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "M",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "N",
        x1: 18,
        y1: 27,
        x2: 121.809,
        y2: 27,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D28E21"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "O",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "P",
        x1: 18,
        y1: 27,
        x2: 121.809,
        y2: 27,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D28E21"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "Q",
        x1: 69.904,
        y1: 14,
        x2: 69.904,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "R",
        x1: 18,
        y1: 27,
        x2: 121.809,
        y2: 27,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D28E21"
    }))))));
};
Logo.displayName = 'Logo';
export default Logo;

//# sourceMappingURL=Logo.dabirthday_24.light.js.map